import React, { useContext, useEffect, useState } from 'react'
import { SessionContext } from '../session-context'
import { useTheme } from '@material-ui/core/styles'
import { getSlots, getDaysDict } from './calendarHelpers'
import DropComplete from './DropComplete'
import EmailConfirmation from './EmailConfirmation'
import DatePicker from './DatePicker'
import { getSlotPickerParams } from '../js/data-providers'

function CalendarDrop (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const theme = useTheme()
  const drop = props.event
  const [slots, setSlots] = useState(null)
  const [status, setStatus] = useState('noDate')
  const [start, setStart] = useState(null)
  const [end, setEnd] = useState(null)
  const [startTimestamp, setStartTimestamp] = useState(null)
  const [endTimestamp, setEndTimestamp] = useState(null)
  const [failedTimeRequest, setFailedTimeRequest] = useState(false)

  const setStartTimes = (dt, ts) => {
    setStart(dt)
    setStartTimestamp(ts)
  }
  const setEndTimes = (dt, ts) => {
    setEnd(dt)
    setEndTimestamp(ts)
  }

  useEffect(() => {
    if (drop && drop.data && !props.completedDrops[drop.event_id]) {
      getSlotPickerParams({ event_id: drop.event_id, token, chatServiceUrl }).then(result => {
        const element_token = result.data.attributes.element_token
        const member_sub = result.data.attributes.member_sub
        getSlots({ element_token, member_sub, drop })
          .then(response => {
            setSlots(getDaysDict(response.available_slots))
          })
      })
    }
    if (failedTimeRequest === true) {
      setStatus('noDate')
    }
  }, [failedTimeRequest, chatServiceUrl, props.completedDrops, drop, token])

  if (!drop || !drop.data) {
    return <></>
  }

  if (props.completedDrops[drop.event_id]) {
    const completeEvent = props.completedDrops[drop.event_id]
    let noTextMessage = true
    if (drop.data.text_message_reminders) {
      noTextMessage = false
    }
    return (
      <DropComplete
        noTextMessage={noTextMessage}
        completeEvent={completeEvent}
        avatarUrl={drop.data.avatar_url}
        agentName={drop.data.agent_name}
        drop={drop}
        completedTextReminder={props.completedTextReminders[drop.event_id]}
      />
    )
  } else if (status === 'dateSelected') {
    return (
      <EmailConfirmation
        avatarUrl={drop.data.avatar_url}
        agentName={drop.data.agent_name}
        drop={drop}
        start={start}
        end={end}
        startTimestamp={startTimestamp}
        endTimestamp={endTimestamp}
        setFailedTimeRequest={setFailedTimeRequest}
      />
    )
  }
  return (
    <DatePicker
      drop={drop}
      avatarUrl={drop.data.avatar_url}
      agentName={drop.data.agent_name}
      slots={slots}
      theme={theme}
      status={status}
      statushandler={setStatus}
      startHandler={setStartTimes}
      endHandler={setEndTimes}
    />
  )
}

export default CalendarDrop
